export default __webpack_public_path__ + "static/media/management-customers-icon.f5d57446.svg";